<template>
  <button
    v-if="summary"
    type="button"
    class="flex w-full items-center gap-1 truncate px-1 text-left text-xs text-gray-700 hover:text-primary-500 dark:text-white"
    :title="summary.first_name"
    @click="openItems"
  >
    <FontAwesomeIcon
      :icon="['fal', 'chevron-down']"
      size="xs"
      class="shrink-0"
    />
    <span class="truncate">{{ summary.first_name }}</span>
    <span
      v-if="summary.count > 1"
      class="shrink-0 rounded-full bg-gray-200 px-1.5 text-[10px] font-semibold text-gray-600"
    >
      +{{ summary.count - 1 }}
    </span>
  </button>
</template>

<script>
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'

export default {
  name: 'DossierItemsCell',
  components: { FontAwesomeIcon },
  props: {
    column: {
      type: Object,
      required: true
    },
    dossier: {
      type: Object,
      required: true
    }
  },
  emits: ['toggle-tasks'],
  computed: {
    summary() {
      return this.dossier[this.column.field] ?? null
    }
  },
  methods: {
    openItems() {
      if (!this.summary?.category_id) {
        return
      }

      this.$emit('toggle-tasks', {
        columnId: this.column.id ?? this.column.field,
        field: [this.summary.category_id],
        onlyWithTasks: false
      })
    }
  }
}
</script>
